<template>
  <ion-content id="app" class="ion-padding">
    <h1>Link bearbeiten</h1>
    <LinkFields modus="edit" :box="box" :id="id"/>
  </ion-content>
</template>

<script>
  import LinkFields from "../../components/link/LinkFields.vue";

  export default {
    name: "LinkEdit",
    components: {LinkFields},
    data(){
      return {
        box: this.$route.params.box,
        id: this.$route.params.id,
      }
    },
  };
</script>

<style>

</style>
